// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___1BY1L","initials":"styles__initials___3Ojpf"};